<template>
    <div class="view-filter-container">
        <span>
            <i @click="emitFilteredEvent($event)" :class="{'active': selectedView === 'one-column'}" class="fal fa-th-list" data-class="one-column"></i>
        </span>

        <span>
            <i @click="emitFilteredEvent($event)" :class="{'active': selectedView === 'three-columns'}" class="fal fa-th" data-class="three-columns"></i>
        </span>

        <span>
            <i @click="emitFilteredEvent($event)" :class="{'active': selectedView === 'two-columns'}" class="fal fa-th-large" data-class="two-columns"></i>
        </span>

    </div>
</template>
<script>
    export default{
        props: {
          'selectedView': {required: false}
        },
        methods: {
            emitFilteredEvent: function(viewOption){
                let element = viewOption.srcElement;
                this.$emit('changed-filter-view', element.dataset.class)
            }
        }
    }
</script>
<style lang="scss" scoped>

    .view-filter-container{
        user-select: none;
        float: right;
        top: 20px;
        right: 20px;

        @media only screen and (max-width: 600px) {
            display: none;
        }

        span{
            display: inline-block;
            cursor: pointer;
            color: black;
            width: 50px;

            i{
                font-size: 25px;
                color: lightgray;
                &:hover {
                    color: black;
                }
            }
        }
    }

    .active{
        color: black !important;
    }

    .night {
        .view-filter-container{
            span{
                .active{
                    color: #FFFFFF !important;
                }
                i{
                    /*color: #FFF !important;*/
                    &:hover{
                        color: #FFFFFF;
                    }
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/site/components/stories/stories-view-filter.vue